export default {"src":"/_next/static/media/Physiotherapy.c8fe07b0.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};